import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { productsData, lineupProductsData, reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KScrollspy } from './common/k-tools/k-tools.js';
import productColorSwitch from './common/colorChips.js';
import LazyLoad from 'vanilla-lazyload';
import videoPlayer from './common/videoPlayer.js';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const anchorBarHandler = () => {
  const anchorBar = $('.anchorBar.fixed');
  const categoryContainer = $('.products__contents');
  const hiddenSection = $('.advice');
  const detectVisibility = () => {
    const scrollTop = $(window).scrollTop();
    // 錨點選單
    if (
      scrollTop >= Math.round(categoryContainer.offset().top) &&
      scrollTop < Math.round(hiddenSection.offset().top) - anchorBar.innerHeight()
    ) {
      anchorBar.addClass('show');
    } else {
      anchorBar.removeClass('show');
    }
  };

  const anchorBars = Array.from(document.querySelectorAll('.anchorBar'));
  anchorBars.forEach(element => {
    const anchorBarItems = element.querySelector('.anchorBar__items');
    const anchorNavPrev = element.querySelector('.anchorBar__nav.prev');
    const anchorNavNext = element.querySelector('.anchorBar__nav.next');
    let anchorBarW = anchorBarItems.clientWidth;
    let anchorBarScrollW = anchorBarItems.scrollWidth;
    let anchorBarScrollLeft = anchorBarItems.scrollLeft;
    anchorNavPrev.classList.add('hidden');
    if (anchorBarScrollW <= anchorBarW) {
      anchorNavNext.classList.add('hidden');
    }
    const scrollHandler = () => {
      anchorBarW = anchorBarItems.clientWidth;
      anchorBarScrollW = anchorBarItems.scrollWidth;
      anchorBarScrollLeft = anchorBarItems.scrollLeft;
      if (anchorBarItems.scrollLeft <= 0) {
        anchorNavPrev.classList.add('hidden');
      } else {
        anchorNavPrev.classList.remove('hidden');
      }
      if (anchorBarW + anchorBarScrollLeft >= anchorBarScrollW) {
        anchorNavNext.classList.add('hidden');
      } else {
        anchorNavNext.classList.remove('hidden');
      }
    };
    const anchorMoveHandler = nav => {
      anchorBarW = anchorBarItems.clientWidth;
      anchorBarScrollW = anchorBarItems.scrollWidth;
      anchorBarScrollLeft = anchorBarItems.scrollLeft;
      const distance = nav === 'prev' ? anchorBarScrollLeft - anchorBarW : anchorBarScrollLeft + anchorBarW;
      gsap.to(anchorBarItems, {
        scrollTo: {
          x: distance,
        },
        duration: 0.3,
        ease: 'ease-in-out',
      });
    };
    anchorBarItems.addEventListener('scroll', scrollHandler);
    anchorNavPrev.addEventListener('click', () => anchorMoveHandler('prev'));
    anchorNavNext.addEventListener('click', () => anchorMoveHandler('next'));
  });

  $(window).on('scroll', detectVisibility);
};

const productTabs = () => {
  const clickHandler = e => {
    const $this = $(e.currentTarget);
    const productCard = $this.parents('.product__card');
    const img = productCard.find('img');
    const name = productCard.find('.name');
    const description = productCard.find('.desc');
    const price = productCard.find('.price .number');
    const url = productCard.find('> a');
    const cartUrl = productCard.find('.add-cart');
    const data = JSON.parse($this.attr('data'));
    $this.siblings('li').removeClass('active');
    $this.addClass('active');
    img.attr('data-src', `./assets/img/products/${data.img.white_bg}`);
    img.attr('src', `./assets/img/products/${data.img.white_bg}`);
    name.text(data.name);
    description.text(data.description);
    price.text(data.price);
    url.attr('href', `https://api.91app.com/es/Redirect/41566/${data.number}`);
    cartUrl.attr('href', `https://api.91app.com/es/Redirect/41566/${data.number}`);
  };

  $('.product__card .tabs').on('click', 'li', clickHandler);
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });
  const scrollspy = new KScrollspy('[k-scrollspy]', {
    onEnter: scrollspyID => {
      const anchorBars = Array.from(document.querySelectorAll('.anchorBar'));
      anchorBars.forEach(anchorBar => {
        const anchorBarItems = anchorBar.querySelector('.anchorBar__items');
        const anchorBarW = anchorBarItems.clientWidth;
        const hasHorizontalScrollbar = element => element.scrollWidth > element.clientWidth;
        if (hasHorizontalScrollbar(anchorBarItems)) {
          const anchorItem = anchorBarItems.querySelector(`.anchorBar__item[k-scrollspy-href="${scrollspyID}"]`);
          const itemW = anchorItem.clientWidth;
          const itemOffsetLeft = anchorItem.offsetLeft;
          const distance = itemOffsetLeft + itemW / 2 - anchorBarW / 2;
          gsap.to(anchorBarItems, {
            scrollTo: {
              x: distance,
            },
            duration: 0.6,
            ease: 'ease-in-out',
          });
        }
      });
    },
  });

  videoPlayer();
  anchorBarHandler();
  productTabs();
  productColorSwitch();
  gsapAnimation();
};

// Vue
createApp({
  setup() {
    const productsDataRef = ref(productsData);
    const lineupProductsDataRef = ref(lineupProductsData);
    const reportDataRef = ref(reportData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      productsDataRef,
      lineupProductsDataRef,
      reportDataRef,
    };
  },
}).mount('#main');
